import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import * as Queries from '@api/graphql/queries';
import { updateUrlAliasVariables, getAllUrlAlias } from '@api/graphql/types';
import { ApplicationState } from 'reducers/';
import { connect } from 'react-redux';
import UrlAliasForm from '../components/UrlAliasForm';

type Props = {
    id: string,
} & InjectedIntlProps & RouteComponentProps<{id: string}>;


interface State {
    formData: updateUrlAliasVariables;
}

class UrlAliasEdit extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            formData: {
                id: '',
                source_url: '',
                target_url: '',
            },
        };
    }

    public componentDidMount() {
        GraphQLClient.query<getAllUrlAlias>({
            query: Queries.getAllUrlAlias,
            variables: {filters: {id: this.props.id}},
        }).then((response) => {
            if (response.data && response.data.getAllUrlAlias) {
                const urlAlias = response.data.getAllUrlAlias.find((alias) => alias.id === this.props.id);
                if (!urlAlias) {
                    throw new Error('not found');
                }
                this.setState({formData: urlAlias});
            }
        });
    }

    public onSubmit = (formData: updateUrlAliasVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.updateUrlAlias, variables: formData,
        });
    }

    public render() {
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>{this.props.intl.formatMessage({ id: 'module.urlAlias.edit.title'})}</h5>
                        </div>
                        <div className="ibox-content">
                            {this.state.formData &&
                                <UrlAliasForm formData={this.state.formData} onSubmit={this.onSubmit}/>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ApplicationState, props: Props) => {
    const { id } = props.match.params;
    return { id };
};

export default compose(
    injectIntl,
    withRouter,
    connect(mapStateToProps),
)(UrlAliasEdit);



// WEBPACK FOOTER //
// ./src/modules/UrlAlias/pages/UrlAliasEdit.tsx